import { useMemo } from 'react';

import { useTemplateDetailsStore } from '@store/templateDetailsStore';

export default function useDefaultTemplateLang() {
  const editor = useTemplateDetailsStore((s) => s.editor);

  const defaultLanguageEditorState = useMemo(
    () => editor.find(({ isDefault }) => isDefault),
    [editor],
  );

  return [defaultLanguageEditorState?.language, defaultLanguageEditorState];
}
